

export interface AloBaseLg {
    lg:string
    libelle:string
}

export const getDefaultAloBaseLg = (lang=''):AloBaseLg => {
    return {
        lg:lang,
        libelle:''
    }
}